// extracted by mini-css-extract-plugin
module.exports = {"forget-pass-box":"ForgetPassword_forget-pass-box__21SNh","logo":"ForgetPassword_logo__2k9i8"};